import { __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { context } from './utils';
import s from './select.module.css';
const Group = ({ label, children }) => {
    return (React.createElement("div", { className: classNames(s.group) },
        label && label.length ? React.createElement("div", { className: classNames(s.section) }, label) : null,
        React.createElement(React.Fragment, null, children)));
};
const NativeGroup = ({ label, children }) => {
    return React.createElement("optgroup", { label: label }, children);
};
const SelectGroup = (_a) => {
    var props = __rest(_a, []);
    const { native } = useContext(context);
    return native ? React.createElement(NativeGroup, Object.assign({}, props)) : React.createElement(Group, Object.assign({}, props));
};
export default SelectGroup;
//# sourceMappingURL=group.js.map